import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { Container } from '~/styles/pagesStyle';
import SearchCard from './SearchCard';

function ModuloEmpresa() {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(false);
  const [modulos, setModulos] = useState([]);

  useEffect(() => {
    setLoading(true);
    async function getModulesData() {
      await api
        .get('/Modulo/GetPaginado/Page/1/Length/1000')
        .then((response) => {
          const { registros } = response.data;
          setLoading(false);
          setModulos(registros);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados dos módulos, recarregue a página');
          setLoading(false);
        });
    }
    getModulesData();
  }, []);

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(modulos).length === 0 ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '10% 50% 0 100px' }}
        />
      ) : (
        <SearchCard
          modulos={modulos}
          loading={loading}
          selected={selected}
          setSelected={setSelected}
          setLoading={setLoading}
        />
      )}
    </Container>
  );
}

export default ModuloEmpresa;
